export default __webpack_public_path__ + "static/media/vegetarian.4c1480f8.png";